import { render, staticRenderFns } from "./dynamicMenu.vue?vue&type=template&id=6a0266e5&"
import script from "./dynamicMenu.vue?vue&type=script&lang=js&"
export * from "./dynamicMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports